import { render, staticRenderFns } from "./MensajeConfirmacionListaArmasDialogComponent.vue?vue&type=template&id=0a81f3c8"
import script from "./MensajeConfirmacionListaArmasDialogComponent.vue?vue&type=script&lang=js"
export * from "./MensajeConfirmacionListaArmasDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports